import moment from 'moment';

import {fetch} from '~/lib/fetch';
import config from '~/configuration';

const retrieve = async (rob_request_id) => {
  const response = await fetch(config.api, {
    method: 'POST',
    body: JSON.stringify({
      query: `
        query Query($rob_request_id: ID!) {
            messages: messages(
              rob_request_id: $rob_request_id
            ) {
              message_id
              activity_id
              timestamp
              status
              dealer_id
              dealer_name
              lessor
              user_name
              content
              attachments {
                  data
                  is_image
              }
            }
        } 
        `,
      variables: {
        rob_request_id,
      },
    }),
  });

  const result = await response.json();

  const messages = {};
  for (const message of result.messages) {
    const date = moment(message.timestamp).format('DD-MM-YYYY');
    if (!messages[date]) {
      messages[date] = [];
    }

    messages[date].push(message);
  }
  return messages;
};

export default {
  retrieve,
};
